export type PlanId =
  | "free"
  | "collector_pro"
  | "seller_pro"
  | "collector_seller_pro";
export const collectorPrice = { monthly: 14.99, annual: 149 } as const;
export const subscriptionPolicy =
  "Paid plans renew automatically until canceled. Cancel anytime; access continues through your paid term. No refunds, prorated refunds or credits, except where required by law.";
export const membershipPlans = [
  {
    id: "free",
    name: "Free",
    audience: "Start your collection and explore.",
    summary: "Binders, scanning, search and market insights.",
    available: true,
    price: "$0",
    cadence: "No subscription charge",
    features: [
      "Binders and Scan & Add",
      "Card search, Sets and Market Insights",
      "Watchlists and Deal Hunter preview",
      "Buy and sell through the marketplace",
    ],
    note: "Seller verification and transaction fees still apply when selling.",
  },
  {
    id: "collector_pro",
    name: "Collector",
    audience: "Build your collection with more guidance.",
    summary: "Full Collection Coach and automatic Deal Hunter.",
    available: true,
    price: "$" + collectorPrice.monthly,
    cadence: "/ month or $" + collectorPrice.annual + " / year",
    features: [
      "Everything in Free",
      "Full Collection Coach analysis",
      "Full Deal Hunter searches",
      "Automatic Deal Hunter monitoring",
    ],
    note: "Billed as Collector Pro. Choose monthly or annual at checkout.",
  },
  {
    id: "seller_pro",
    name: "Seller",
    audience: "Tools to manage and grow your shop.",
    summary: "Shop analytics and bulk pricing tools.",
    available: false,
    price: "Coming soon",
    cadence: "Pricing to be announced",
    features: [
      "Seller analytics and sales exports · Dev preview",
      "Bulk asking-price updates · Dev preview",
      "Shipping presets · planned",
      "Scheduled publishing · planned",
    ],
    note: "Paid Seller subscriptions are not available yet. Core selling remains available on Free after onboarding.",
  },
  {
    id: "collector_seller_pro",
    name: "Combined Collector + Seller",
    audience: "Collect and run your shop in one plan.",
    summary: "Collector benefits and Seller tools together.",
    available: false,
    price: "Coming soon",
    cadence: "Pricing to be announced",
    features: [
      "Collector benefits",
      "Seller tools in one subscription · planned",
      "One place to manage membership and billing",
    ],
    note: "The combined subscription is not available yet. Its Seller benefits remain in preview or planned.",
  },
] as const;
export function parsePlanId(value: unknown): PlanId | null {
  return typeof value === "string" &&
    membershipPlans.some((plan) => plan.id === value)
    ? (value as PlanId)
    : null;
}
export function planPath(plan: PlanId = "free") {
  return "/plans?plan=" + plan;
}
export function planById(plan: PlanId) {
  return membershipPlans.find((item) => item.id === plan)!;
}
const intentKey = "pokellama:membership-intent:v1";
const intentLifetime = 30 * 60 * 1000;
// A navigation preference only. Paid access always comes from the billing API.
export function rememberPlanIntent(plan: PlanId) {
  try {
    sessionStorage.setItem(
      intentKey,
      JSON.stringify({ plan, createdAt: Date.now() }),
    );
  } catch {
    /* Storage may be unavailable. */
  }
}
export function readPlanIntent(): PlanId | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(intentKey) || "null");
    if (
      !value ||
      !Number.isFinite(value.createdAt) ||
      Date.now() - value.createdAt > intentLifetime ||
      value.createdAt > Date.now()
    )
      return null;
    return parsePlanId(value.plan);
  } catch {
    return null;
  }
}
export function clearPlanIntent() {
  try {
    sessionStorage.removeItem(intentKey);
  } catch {
    /* Storage may be unavailable. */
  }
}
